function TutorSubmission({ fill, width, height }) {
  return (
    <svg
      width={width ? width : "20"}
      height={height ? height : "23"}
      viewBox="0 0 20 23"
      fill={fill ? fill : "#A5A5A5"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.61111 6.11109C2.61111 5.52812 3.08369 5.05554 3.66666 5.05554L3.66666 5.05559C3.66666 6.22152 4.61184 7.1667 5.77777 7.1667H14.2222C15.3881 7.1667 16.3333 6.22152 16.3333 5.05559L16.3333 5.05554C16.9163 5.05554 17.3889 5.52812 17.3889 6.11109V19.8333C17.3889 20.4163 16.9163 20.8888 16.3333 20.8888H3.66666C3.08369 20.8888 2.61111 20.4163 2.61111 19.8333V6.11109ZM14.2222 0.833374C15.3881 0.833374 16.3333 1.77852 16.3333 2.94443C18.0822 2.94443 19.5 4.36219 19.5 6.11109V19.8333C19.5 21.5822 18.0822 23 16.3333 23H3.66666C1.91776 23 0.5 21.5822 0.5 19.8333V6.11109C0.5 4.36219 1.91776 2.94443 3.66666 2.94443C3.66669 1.77852 4.61185 0.833374 5.77777 0.833374H14.2222ZM14.2222 2.94448H5.77777V5.05559H14.2222V2.94448ZM14.4408 13.1908C14.853 12.7786 14.853 12.1103 14.4408 11.698C14.0286 11.2858 13.3603 11.2858 12.948 11.698L9.47221 15.1739L7.57971 13.2814C7.16749 12.8692 6.49915 12.8692 6.08693 13.2814C5.67472 13.6936 5.67472 14.3619 6.08693 14.7742L7.97943 16.6667C8.80387 17.4911 10.1405 17.4911 10.965 16.6667L14.4408 13.1908Z"
        fill={fill ? fill : "#A5A5A5"}
      />
    </svg>
  )
}

export default TutorSubmission
